export const timeZones = [
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'America/Adak',
  'Pacific/Honolulu',
  'America/Samoa',
  'Pacific/Guam',
] as const;

export const timeZoneOptions = timeZones.map((timeZone) => ({
  id: timeZone,
  label: timeZone,
  value: timeZone,
}));
